import { displayTextLabelValidator, nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultShowtimeContextDisplayText = {
    futureAdvanceBookingPeriodTitle: 'Showtime not yet available',
    futureAdvanceBookingPeriodMessage: 'This is an advance booking showtime. Tickets on sale from ${bookingPeriodStartsAt|d|Do of MMMM, h:mm A}.',
    futureAdvanceBookingPeriodTodayMessage: 'This is an advance booking showtime. Tickets on sale today from ${bookingPeriodStartsAt|d|h:mm A}.',
    failedToLoadDataTitle: 'Showtime unavailable',
    failedToLoadDataMessage: "We can't access this showtime at the moment. Please try again soon.",
    messageActionButtonLabel: 'Return to home'
};
export const showtimeContextDisplayTextValidator = Validator.object({
    futureAdvanceBookingPeriodTitle: nonEmptyStringValidator,
    futureAdvanceBookingPeriodMessage: displayTextLabelValidator,
    futureAdvanceBookingPeriodTodayMessage: displayTextLabelValidator,
    failedToLoadDataTitle: nonEmptyStringValidator,
    failedToLoadDataMessage: displayTextLabelValidator,
    messageActionButtonLabel: nonEmptyStringValidator
});
